export default __webpack_public_path__ + "static/media/award.48764590.svg";